import uniqueId from 'lodash/uniqueId';
import isArray from 'lodash/isArray';
import blockFactory from './factory';
import frame, { FRAME_STYLE } from '../props/frame';
import actionFactory from '../props/action';
import align, { ALIGNMENT } from '../props/align';
import sizeTrait from '../props/size-trait';
import direction, { CONTAINER_DIRECTION } from '../props/direction';
import background from '../props/background';
import { sumWeight, getMaxWeight } from '../../util';

export var DEFAULT_FRAME_STYLE = FRAME_STYLE.onlyRoundCorners;
export var DEFAULT_FRAME_COLOR = '';

/**
 * Билдер блока div-container-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-container-block.json
 * @param {Object} block
 * @param {Object}
 */
export default (function (block) {
    var width = sizeTrait(block.width);

    if (!width) {
        return null;
    }

    var height = sizeTrait(block.height);

    if (!height) {
        return null;
    }

    var rawChildren = block.children;

    if (!rawChildren || !isArray(rawChildren)) {
        return null;
    }

    var children = rawChildren.map(blockFactory).filter(Boolean);

    if (!children.length) {
        return null;
    }

    var blockDirection = direction(block.direction);
    var weight = blockDirection === CONTAINER_DIRECTION.vertical ? sumWeight(children) : getMaxWeight(children);

    return {
        action: actionFactory(block),
        frame: frame(block.frame, DEFAULT_FRAME_STYLE, DEFAULT_FRAME_COLOR),
        direction: blockDirection,
        horizontalAlignment: align(block.alignment_horizontal),
        verticalAlignment: align(block.alignment_vertical, ALIGNMENT.top),
        type: block.type,
        background: background(block.background),
        width: width,
        height: height,
        children: children,
        id: uniqueId('block_'),
        weight: weight,
        hasGallery: children.some(function (block) {
            return block.hasGallery;
        }),
        hasTabs: children.some(function (block) {
            return block.hasTabs;
        })
    };
});